import { z } from 'zod';
export const featureFlag = z.enum([
    'approve_and_next',
    'column_picker',
    'crossborder_multiple_providers_enabled',
    'custom_roles_enabled',
    'global_only_convert_csv_to_pdf',
    'global_only_vendors_payables_only',
    'inbox_side_by_side',
    'item_form_consolidated_loader',
    'line_items_table_expand_collapse_ux',
    'marketing_site_embedded_login',
    'ocr_embedded_mode',
    'payables_filter_default',
    'payables_status_filter',
    'predictive_coding_inbox_ui_nonfunctional',
    'predictive_coding_messaging',
    'summarize_separate_ui_changes',
    'table_builder_field_id_update',
    'use_new_partnership_select',
]);
export const featureFlagsApiResponseModel = z.array(z.object({ featureFlag }));
export const featureFlagsMapModel = z.record(featureFlag, z.boolean());
